import CaseManage from "@/views/casemanage/CaseManage"
export const casemanage = {
    path: '/casemanage',
    name: 'CaseManage',
    component: CaseManage
  }


// WEBPACK FOOTER //
// ./src/router/index/casemanage/index.js